export default __webpack_public_path__ + "static/media/krati_core.1fc0c5c1.jpg";